/* eslint-disable no-plusplus */
import React from 'react';
import { Helmet } from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';
import Twitter from './Twitter';
import Facebook from './Facebook';
import dictionary from '../../utils/dictionary';

const SEO = ({
  title = null,
  description = null,
  image = null,
  pathname = null,
  article = false,
  showSchema = false,
  breadcrumbs = null,
}) => (
  <StaticQuery
    query={graphql`
      query SEOQuery {
        site {
          siteMetadata {
            defaultTitle: title
            titleTemplate
            defaultDescription: description
            siteUrl: url
            defaultImage: image
          }
        }
      }
    `}
    render={({
      site: {
        siteMetadata: {
          defaultTitle,
          titleTemplate,
          defaultDescription,
          siteUrl,
          defaultImage,
          twitterUsername,
          facebookAppID,
        },
      },
    }) => {
      const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: `${siteUrl}${image || defaultImage}`,
        siteUrl: `${siteUrl}${pathname || '/'}`,
      };

      const breadcrumbsArray = breadcrumbs && [];
      let breadcrumbPosition = 1;

      if (breadcrumbs) {
        breadcrumbs.forEach((element) => {
          const url = element.slug ? `${siteUrl}/${element.slug}/` : `${siteUrl}/`;
          const breadcrumbRepresentation = {
            '@type': 'ListItem',
            position: breadcrumbPosition,
            name: element.title,
            item: url,
          };
          breadcrumbsArray.push(JSON.stringify(breadcrumbRepresentation));
          breadcrumbPosition++;
        });
      }
      const google_site_verification = process.env.GOOGLE_SITE_VERIFICATION;
      return (
        <>
          <Helmet title={seo.title} titleTemplate={titleTemplate}>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            <meta name="google-site-verification" content={google_site_verification} />
            <html lang="th" />
            {showSchema && (
              <script type="application/ld+json">
                {`
                  {
                    "@context": "https://schema.org",
                    "@type": "WebSite",
                    "name": "${seo.title}",
                    "url": "${siteUrl}${pathname || '/'}",
                    "description": "${seo.description}",
                    "sameAs": "${dictionary.lineLink}"
                  }
                `}
              </script>
            )}
            {breadcrumbsArray && (
              <script type="application/ld+json">
                {`
            {
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [${breadcrumbsArray}]
            }
            `}
              </script>
            )}
          </Helmet>
          <Facebook
            pageUrl={seo.siteUrl}
            type={article ? 'article' : null}
            title={seo.title}
            description={seo.description}
            image={seo.image}
            appID={facebookAppID}
          />
          <Twitter username={twitterUsername} title={seo.title} description={seo.description} image={seo.image} />
        </>
      );
    }}
  />
);

export default SEO;
